var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRastreamentoCor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_1349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1815 36.7345L22.182 18.5634L35.8125 11.2939V29.4389L22.1815 36.7345Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.182 36.7374L22.1815 18.5669L8.55099 11.2974V29.4424L22.182 36.7374Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55148 11.2974L22.182 18.5634L35.8125 11.2939L22.182 4.02441L8.55148 11.2974Z",
    fill: "#CD992B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55148 11.2973L22.182 4.02783L22.1815 18.5633L8.55148 11.2973Z",
    fill: "#A65718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1818 18.5636L18.5375 24.3917C18.2935 24.782 17.9104 25.0651 17.4657 25.184C17.021 25.3028 16.5478 25.2485 16.1416 25.032L5.72627 19.4799C5.50634 19.3627 5.31287 19.2015 5.15789 19.0063C5.00291 18.8111 4.88973 18.5861 4.82539 18.3453C4.76105 18.1045 4.74693 17.8531 4.78389 17.6066C4.82086 17.3602 4.90813 17.1239 5.04027 16.9126L8.55127 11.2976L22.1818 18.5636Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1818 18.5636L25.8261 24.3917C26.0701 24.782 26.4532 25.0651 26.8979 25.184C27.3426 25.3028 27.8158 25.2485 28.222 25.032L38.6374 19.4799C38.8573 19.3627 39.0508 19.2015 39.2058 19.0063C39.3608 18.8111 39.4739 18.5861 39.5383 18.3453C39.6026 18.1045 39.6167 17.8531 39.5798 17.6066C39.5428 17.3602 39.4555 17.1239 39.3234 16.9126L35.8124 11.2976L22.1818 18.5636Z",
    fill: "#EFAF0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0308 32.0163C33.6403 31.6258 33.0071 31.6258 32.6166 32.0163C32.2261 32.4068 32.2261 33.04 32.6166 33.4305L36.5294 37.3433C36.9199 37.7338 37.5531 37.7338 37.9436 37.3433C38.3341 36.9527 38.3341 36.3196 37.9436 35.9291L34.0308 32.0163Z",
    fill: "#0083CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7397 33.9089L34.5089 35.1397C34.0678 35.5808 34.0678 36.2961 34.5089 36.7373L39.1412 41.3696C39.5824 41.8107 40.2977 41.8107 40.7388 41.3696L41.9696 40.1388C42.4108 39.6976 42.4108 38.9823 41.9696 38.5411L37.3374 33.9089C36.8962 33.4677 36.1809 33.4677 35.7397 33.9089Z",
    fill: "#00416B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3418 35.434C25.6206 35.434 23.9382 34.9236 22.5071 33.9674C21.0761 33.0112 19.9607 31.6521 19.3021 30.062C18.6434 28.4719 18.4711 26.7222 18.8069 25.0342C19.1426 23.3462 19.9714 21.7956 21.1884 20.5786C22.4054 19.3616 23.956 18.5328 25.6441 18.197C27.3321 17.8612 29.0818 18.0336 30.6719 18.6922C32.262 19.3508 33.6211 20.4662 34.5773 21.8973C35.5335 23.3283 36.0439 25.0108 36.0439 26.7319C36.0412 29.039 35.1236 31.2509 33.4922 32.8823C31.8608 34.5137 29.6489 35.4314 27.3418 35.434ZM27.3418 20.4822C26.1057 20.4822 24.8974 20.8488 23.8696 21.5355C22.8418 22.2222 22.0408 23.1983 21.5677 24.3403C21.0947 25.4822 20.9709 26.7389 21.2121 27.9512C21.4532 29.1635 22.0485 30.2771 22.9225 31.1511C23.7965 32.0252 24.9101 32.6204 26.1225 32.8616C27.3348 33.1027 28.5914 32.9789 29.7334 32.5059C30.8754 32.0329 31.8514 31.2318 32.5382 30.2041C33.2249 29.1763 33.5914 27.968 33.5914 26.7319C33.5896 25.0749 32.9305 23.4864 31.7589 22.3148C30.5872 21.1431 28.9987 20.4841 27.3418 20.4822Z",
    fill: "#00416B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_1349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.600006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRastreamentoCor);
export default __webpack_public_path__ + "static/media/rastreamento-cor.8aa5467c957f3fd9f6a28871a239640e.svg";
export { ForwardRef as ReactComponent };